"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Toasts = void 0;

var _react = _interopRequireDefault(require("react"));

var _VisuallyHidden = require("../VisuallyHidden");

var _Box = require("../Box");

var _Join = require("../Join");

var _Spacer = require("../Spacer");

var _Toast = require("./Toast");

var _useToasts2 = require("./useToasts");

var _excluded = ["limit"],
    _excluded2 = ["id"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Toasts = function Toasts(_ref) {
  var _ref$limit = _ref.limit,
      limit = _ref$limit === void 0 ? 5 : _ref$limit,
      rest = _objectWithoutProperties(_ref, _excluded);

  var _useToasts = (0, _useToasts2.useToasts)(),
      toasts = _useToasts.toasts;

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Box.Box, rest, /*#__PURE__*/_react.default.createElement(_Join.Join, {
    separator: /*#__PURE__*/_react.default.createElement(_Spacer.Spacer, {
      y: 1
    })
  }, takeRight(toasts, limit).map(function (_ref2) {
    var id = _ref2.id,
        rest = _objectWithoutProperties(_ref2, _excluded2);

    return /*#__PURE__*/_react.default.createElement(_Toast.Toast, _extends({
      key: id,
      id: id
    }, rest));
  }))), /*#__PURE__*/_react.default.createElement(_VisuallyHidden.VisuallyHidden, {
    "aria-live": "assertive",
    "aria-atomic": "true",
    "aria-relevant": "additions"
  }, toasts.map(function (toast, i) {
    return /*#__PURE__*/_react.default.createElement("div", {
      key: i
    }, toast.message, " - ", toast.description);
  })));
};

exports.Toasts = Toasts;

var takeRight = function takeRight(xs) {
  var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

  if (xs.length < limit) {
    return xs;
  }

  return xs.slice(xs.length - limit, xs.length);
};
//# sourceMappingURL=Toasts.js.map